import { Box, Skeleton, Stack } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";

export const CardTransactionItemSkeleton = () => (
  <Box
    width="100%"
    mt={2.5}
    pb={1.5}
    borderBottom={`1px solid ${Colors.MediumGrey}`}
  >
    <Box display="flex" justifyContent="space-between">
      <Box display="flex" alignItems="center" gap={4}>
        <Skeleton variant="rounded" width={24} height={24} />
        <Stack gap={0.5}>
          <Skeleton variant="text" width={120} height={21} />
          <Skeleton variant="text" width={90} height={18} />
        </Stack>
      </Box>
      <Box display="flex" alignItems="center">
        <Stack alignItems="flex-end" gap={0.5}>
          <Skeleton variant="text" width={80} height={20} />
          <Skeleton variant="text" width={60} height={16} />
        </Stack>
      </Box>
    </Box>
  </Box>
);
